"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.PaymentAPI = {
    getPayments: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios
                        .get("/api/v1/company/" + companyId + "/payments?" + (filter ? filter.getQueryString() : ''))
                        .then(function (response) {
                        var paginatedPayment = response.data;
                        return paginatedPayment;
                    })];
            });
        });
    },
    getPaymentById: function (companyId, paymentId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/payments/" + paymentId).then(function (response) {
                        var payment = response.data;
                        return payment;
                    })];
            });
        });
    },
    getPaymentsAtLocation: function (companyId, locationId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios
                        .get("/api/v1/company/" + companyId + "/location/" + locationId + "/payments?" + filter.getQueryString())
                        .then(function (response) {
                        var paginatedPayment = response.data;
                        var paginatedPayments = {
                            payments: paginatedPayment.payments,
                            limit: paginatedPayment.limit,
                            offset: paginatedPayment.offset,
                            total: paginatedPayment.total,
                        };
                        return paginatedPayments;
                    })];
            });
        });
    },
    addPayment: function (companyId, locationId, payment, adjustInventory, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            var url, notesExist, newNotes;
            return __generator(this, function (_a) {
                url = "/api/v1/company/" + companyId + "/location/" + locationId + "/payments?";
                if (adjustInventory !== undefined) {
                    if (adjustInventory) {
                        url += 'adjustInventory=true&';
                    }
                    else {
                        url += 'adjustInventory=false&';
                    }
                }
                // Add overriden negative invetory products into "notes" if manager's information exists
                if (payment.overridenManager) {
                    notesExist = payment.notes ? payment.notes.trim().length !== 0 : false;
                    newNotes = "Negative Inventory Sale override by " + payment.overridenManager.name;
                    payment.notes = notesExist ? payment.notes + "\n" + newNotes : newNotes;
                }
                return [2 /*return*/, index_1.axios.post(url, payment, { timeout: timeout }).then(function (response) {
                        var createdPayment = response.data.payment;
                        return createdPayment;
                    })];
            });
        });
    },
    updatePayment: function (companyId, paymentId, editPayment, editMetadata) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/api/v1/company/" + companyId + "/payments/" + paymentId + "?";
                if (editMetadata) {
                    if (editMetadata.floatAdjustment) {
                        url += "floatAdjustment=" + editMetadata.floatAdjustment + "&";
                    }
                    if (editMetadata.employeeId) {
                        url += "employeeId=" + editMetadata.employeeId + "&";
                    }
                    if (editMetadata.notes) {
                        url += "notes=" + editMetadata.notes + "&";
                    }
                }
                return [2 /*return*/, index_1.axios.put(url, editPayment).then(function (response) {
                        var payment = response.data.payment;
                        return payment;
                    })];
            });
        });
    },
    refundPayment: function (companyId, locationId, paymentId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios
                        .post("/api/v1/company/" + companyId + "/location/" + locationId + "/payments/" + paymentId + "/refund")
                        .then(function (response) {
                        var payment = response.data.refund;
                        return payment;
                    })];
            });
        });
    },
    completePayment: function (companyId, locationId, paymentId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios
                        .post("/api/v1/company/" + companyId + "/location/" + locationId + "/payments/" + paymentId + "/complete")
                        .then(function (response) {
                        var payment = response.data.payment;
                        return payment;
                    })];
            });
        });
    },
    inProgressPayment: function (companyId, locationId, paymentId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios
                        .post("/api/v1/company/" + companyId + "/location/" + locationId + "/payments/" + paymentId + "/inProgress")
                        .then(function (response) {
                        var payment = response.data.payment;
                        return payment;
                    })];
            });
        });
    },
    cancelPayment: function (companyId, locationId, paymentId, userId, notes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios
                        .post("/api/v1/company/" + companyId + "/location/" + locationId + "/payments/" + paymentId + "/cancel", {
                        userId: userId,
                        notes: notes,
                    })
                        .then(function (response) {
                        var payment = response.data.payment;
                        return payment;
                    })];
            });
        });
    },
    sendReceiptEmail: function (companyId, paymentId, email, paymentOptionNames) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios
                        .post("/api/v1/company/" + companyId + "/payments/" + paymentId + "/emailReceipt?email=" + email, paymentOptionNames)
                        .then(function (response) { return response.data; })];
            });
        });
    },
    getRefundedPayment: function (companyId, paymentId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios
                        .get("/api/v1/company/" + companyId + "/payments/" + paymentId + "/refunded")
                        .then(function (response) { return response.data; })];
            });
        });
    },
};
//# sourceMappingURL=PaymentAPI.js.map